// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"223be989","461":"5cc17844","666":"a22d0f82","787":"aa31955a"}[chunkId] + ".chunk.js";
};